import React from 'react';

const SvgLikeIcon = () => (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 20V7L13 0L14.85 1.85L13.55 7H21V11.4L17.35 20H6ZM0 20V7H4V20H0Z" fill="#F7A36C"/>
    </svg>
);

export default SvgLikeIcon;
